<template>
  <section style="padding-left:36px;">
    <div class="task-approval" v-for="(item, index) in processArr" :key="item.index" :class="[
        item.isCrossThisTask || item.isOnThisTask ? 'active' : '',
        item.styleTab ? 'active1' : ''
      ]">
      <div class="task-step">
        <div v-if="index === 0" class="start-date active"></div>
        <div v-else-if="index === processArr.length - 1"
          :class="[item.noPassType === 0 ? 'start-date' : 'start-end',item.isCrossThisTask || item.isOnThisTask ? '':'start-date2']">
        </div>
        <div v-else class="start-date1 bg-default">
          {{ index }}</div>
        <div class="start-text">
          {{ item.taskName }}</div>
        <div v-if="index !== 0 && index !== processArr.length - 1">
          <div v-if="item.isCrossThisTask || item.isOnThisTask" class="stop-time">
            <span>(停留时长 :
              {{ item.stopTimeName }})</span>
          </div>
        </div>
      </div>
      <div class="placeholder-content" :class="{
          break: index < breakTastIndex,
          cancel: index + 1 === processArr.length
        }">
        <div class="start-content">
          <template v-if="item.mergeList.length > 0">
            <div v-for="(ele, index) in item.mergeList" :key="index" class="start-content-div">
              <!-- commentList mergeList 排序后 理论上会合并在一个数组中 commentListState 附言的数据-->
              <template v-if="ele.commentListState">
                <div class="contents">
                  <div class="task-time">
                    【附言】：{{ ele.userName }}</div>
                  <div class="task-time task-time1" v-if="ele.commentDate">
                    {{ ele.commentDate }}
                  </div>
                  <div class="task-thing">
                    <template v-if="ele.imgUrl && ele.imgUrl.split(',').length">
                      <img v-for="(val, i) in ele.imgUrl.split(',')" :key="i"
                        style="width:40px;height:40px;margin:0px 8px 12px 0px;cursor: pointer;" :src="val"
                        @click="previewImage(val)" />
                    </template>
                    {{ contentSplit(ele) }}
                    <span class="text-link" v-if="ele.showButton"
                      @click="handleShowMore(ele)">查看详情</span>
                  </div>
                </div>
              </template>

              <template v-else-if="ele.transferCommentListState">
                <div class="contents">
                  <div class="task-time">
                    【转交】：{{ ele.userName }}{{ ele.content.substring(0,ele.content.indexOf('：') -2 ) }}
                  </div>
                  <div class="task-time">
                    备注{{  ele.content.substring(ele.content.indexOf('：'),ele.content.length)  }}
                  </div>
                  <div class="task-time task-time1" v-if="ele.commentDate">
                    {{ ele.commentDate }}
                  </div>
                  <div class="task-thing">
                    <template v-if="ele.imgUrl && ele.imgUrl.split(',').length">
                      <img v-for="(val, i) in ele.imgUrl.split(',')" :key="i"
                        style="width:40px;height:40px;margin:0px 8px 12px 0px;cursor: pointer;" :src="val"
                        @click="previewImage(val)" />
                    </template>
                    <!-- {{ ele.content }}
                    <span class="text-link" v-if="ele.showButton"
                      @click="handleShowMore(ele)">查看详情</span> -->
                  </div>
                </div>
              </template>

              <template v-else>
                <div class="contents">
                  <div class="task-time" v-if="ele.userName">
                    {{ ele.userName }}
                  </div>
                  <div class="task-time" v-if="ele.startDate">
                    {{ ele.startDate }}
                  </div>
                  <!-- // reject === 1有驳回 -->
                  <div class="task-time" v-if="ele.reject === 1">
                    <span>驳回:</span>
                    <span>备注:</span>
                    <span>{{ ele.replyMessage }}</span>
                  </div>
                  <div v-else class="task-thing">
                    {{ ele.replyMessage }}</div>
                </div>
                <template v-if="ele.attachment && ele.attachment.split(',').length">
                  <img v-for="(val, i) in ele.attachment.split(',')" :key="i"
                    style="width:40px;height:40px;margin:0px 8px 12px 0px;cursor: pointer;" :src="val"
                    @click="previewImage(val)" />
                </template>
              </template>
            </div>
          </template>
          <!--  commentList 附言列表 理论上不会走到这里了 -->
          <template v-if="item.commentList.length > 0">
            <div class="contents" v-for="comment in item.commentList" :key="comment.id">
              <div class="task-time" v-if="comment.commentDate">
                {{ comment.commentDate }}
              </div>
              <div class="task-time">
                {{ comment.userName }}</div>
              <div class="task-thing">
                <template v-if="comment.imgUrl && comment.imgUrl.split(',').length">
                  <img v-for="(val, i) in comment.imgUrl.split(',')" :key="i"
                    style="width:40px;height:40px;margin:0px 8px 12px 0px;cursor: pointer;" :src="val"
                    @click="previewImage(val)" />
                </template>
                {{ contentSplit(comment) }}
                <!-- <span class="text-link" v-if="comment.showButton" @click="comment.showMore=true">查看详情</span> -->
                <span class="text-link" v-if="comment.showButton"
                  @click="handleShowMore(comment)">查看详情</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <image-preview :visible="imagePreviewDialog" :imgSrc="imgSrc" :modal="false"
      @close="closeDialog"></image-preview>
  </section>
</template>

<script>
import ImagePreview from '@/components/common/ImagePreview'
import { mapGetters } from 'vuex'

export default {
  name: 'flowTaskTracking',
  components: {
    ImagePreview
  },
  props: {
    // processArr: {
    //   type: Array,
    //   default: () => [],
    // },
    processId: {
      type: String,
      default: '',
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    nodeTaskId: {
      // 用户我的任务返回当前节点id的
      type: String,
      default: ''
    }
  },
  watch: {
    show: function () {
      if (this.processId) {
        this.getProcessInfo()
      }
    }
  },
  filters: {},
  computed: {
    ...mapGetters(['userInfo']),
    breakTastIndex () {
      const index = this.processArr.findIndex(item => item.isOnThisTask)
      return index
    }
  },
  data () {
    return {
      imagePreviewDialog: false,
      imgSrc: '',
      processArr: []
    }
  },
  created () {
    if (this.processId) {
      this.getProcessInfo()
    }
  },
  methods: {
    previewImage (src) {
      this.imgSrc = src
      this.imagePreviewDialog = true
    },
    closeDialog () {
      this.imagePreviewDialog = false
    },
    getProcessInfo () {
      let params = {
        processInstanceId: this.processId,
        type: 0,
        userId: this.userInfo.id
      }
      this.api.task.getTaskNodeList1(params).then(data => {
        if (data.errorMessage) {
          this.$message.error(data.errorMessage)
        } else {
          let activeIndex = -1
          data.body.forEach((item, index) => {
            item.mergeList.push({
              startDate: item.startDate,
              userName: item.remark
            }) // 添加一个 startDate数据
            if (item.countersign === 0) {
              //  // 添加一个 或签 的数

              item.mergeList.push({
                startDate: item.applyDate,
                userName: item.userName,
                reject: item.reject,
                replyMessage: item.replyMessage,
                attachment: item.attachment
              })
            }
            item.mergeList.forEach(item1 => {
              item1.commentListState = false
              if (item1.replyDate) {
                item1.startDate1 = item1.replyDate
                item1.startDate = this.utils.timeFormat2(item1.replyDate, true)
              } else {
                item1.startDate1 = Date.parse(new Date(item1.startDate))
              }
            })
            if (item.commentList.length > 0) {
              item.commentList.forEach(item2 => {
                item2.commentListState = true
                item2.startDate1 = Date.parse(new Date(item2.commentDate))
              })
            }
            if (item.transferCommentList.length > 0) {
              item.transferCommentList.forEach(item3 => {
                item3.transferCommentListState = true
                item3.startDate1 = Date.parse(new Date(item3.commentDate))
                item.mergeList.push(item3)
              })
            }
            item.mergeList = item.mergeList.concat(item.commentList)
            item.mergeList.sort((a, b) => {
              return a.startDate1 - b.startDate1
            })
            item.commentList = []
            if (
              !item.isCrossThisTask && !item.isOnThisTask && activeIndex === -1
            ) {
              activeIndex = index - 1
              data.body[activeIndex].styleTab = true
            }
            if (item.isCrossThisTask || item.isOnThisTask) {
              let startDate1 = item.applyDate ? item.applyDate : new Date().getTime()
              console.log(startDate1, 'startDate1')
              item.stopTimeName = this.getStopTime(this.utils.dateToTimestamp(item.startDate), this.utils.dateToTimestamp(startDate1))
            }
          })
          console.log(data.body)
          if (activeIndex === -1) {
            data.body[data.body.length - 1].styleTab = true
          }
          this.processArr = data.body || []
          const nodeTaskId = this.processArr.find(
            process => process.isOnThisTask
          ).taskId
          this.$emit('update:nodeTaskId', nodeTaskId)
        }
      })
    },
    handleShowMore (item) {
      this.$set(item, 'showMore', true)
    },
    // 1
    getStopTime (time, time1) {
      let time2 = time1 - time
      let time01 = 1000 * 60 * 60 * 24 // 天
      let time02 = 1000 * 60 * 60 // 时
      let time03 = 1000 * 60 // 分
      let name = ''
      console.log(time2)

      if (time2 > time01) {
        let num = parseInt(time2 / time01)
        let num1 = parseInt((time2 - num * time01) / time02)
        if (num1) {
          name = num + '天' + num1 + '小时' + parseInt((time2 - num * time01 - num1 * time02) / time03) + '分钟'
        } else {
          name =
            num +
            '天' +
            parseInt((time2 - num * time01 - num1 * time02) / time03) +
            '分钟'
        }
      } else if (time2 > time02) {
        let num = parseInt(time2 / time02)
        name = num + '小时'
        name = name + parseInt((time2 - num * time02) / time03) + '分钟'
      } else if (time2 > time03) {
        name = parseInt(time2 / time03) + '分钟'
      } else {
        name = parseInt(time2 / 1000) + '秒'
      }
      return name
    },
    contentSplit (item) {
      item.showButton = item.content.length > 10
      let result =
        item.content.substring(0, 10) + (item.content.length > 10 ? '...' : '')
      if (item.showMore) {
        result = item.content
        item.showButton = false
      }
      return result
    }
  }
}
</script>
<style lang="less" scoped>
.task-step {
  display: flex;
  margin-bottom: 6px;
  .start-date {
    width: 28px;
    height: 28px;
    margin-right: 12px;
    background: url("../../assets/images/start.png") center center no-repeat;
    background-size: 28px 28px;
  }
  .start-date2 {
     background: url("../../assets/images/start_false.png") center center no-repeat;
    background-size: 28px 28px;
  }
  .start-text {
    font-size: 16px;
    color: #333333;
    text-align: left;
    line-height: 28px;
  }
  .start-end {
    font-size: 16px;
    color: #fff;
    text-align: left;
    width: 28px;
    height: 28px;
    border-radius: 28px;
    line-height: 28px;
    background: url("../../assets/images/start-end.png") no-repeat
      center/100% 100% !important;
    text-align: center;
    margin-right: 12px;
  }
  .stop-time {
    line-height: 28px;
    font-size: 14px;
    margin-left: 12px;
  }
}
.placeholder-content {
  margin-left: 14px;
  border-left: 1px solid rgba(0, 0, 0, 0.25);
  min-height: 33px;
  font-size: 12px;
  color: #333333;
  text-align: left;
  line-height: 12px;
  .start-content {
    margin-left: 27px;
    padding-bottom: 12px;
    margin-bottom: 7px;
    .contents {
      margin-bottom: 30px;
      // display: flex;
      // align-items: center;
      position: relative;
      &::after {
        position: absolute;
        width: 260px;
        height: 1px;
        content: "";
        bottom: -10px;
        left: 0px;
        background-color: #f4f4f4;
      }
    }
  }
  .start-content-div:last-child {
    .contents {
      margin-bottom: 10px;
      &::after {
        display: none;
      }
    }
  }
  .task-time {
    margin-right: 8px;
    flex-shrink: 0;
    line-height: 20px;
    margin-top: 6px;
  }
  .task-time1 {
    width: 123px;
    margin-right: 0px;
    white-space: nowrap;
  }
  &.cancel {
    border: none;
    min-height: 0;
  }
  &.break {
    border-left: 1px solid #009dc2;
  }
  .task-thing {
    word-break: break-all;
    display: flex;
    align-items: center;
    line-height: 20px;
    margin-top: 6px;
  }
}
.task-approval {
  color: #999999;
  background-color: #ffffff;
  .start-text {
    color: #666666;
  }
  .task-time {
    color: #999999;
  }
  .task-thing {
    color: #999999;
  }
  &.active {
    .start-date1 {
      width: 28px;
      height: 28px;
      border-radius: 28px;
      border: none;
      color: #ffffff;
      background-color: #009ba8;
    }
  }
  &.active1 {
    color: #333333;
    .task-time {
      color: #333333;
    }
    .task-thing {
      color: #333333;
    }
    .start-text {
      color: #333333;
    }
  }
  .start-date1 {
    margin-right: 12px;
    width: 24px;
    height: 24px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-radius: 24px;
    color: rgba(0, 0, 0, 0.25);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/area-base/components/common/FlowTaskTracking.vue